module.exports = __webpack_public_path__ + "assets/apple-pay.c9308778.svg";